<template>
    <el-container class="collected-page">
        <!-- 左侧：目录导航面板 -->
        <el-aside id="doc-menu-aside" class="doc-nav" width="280px">
            <div class="doc-nav__search">
                <el-input placeholder="搜索文档" v-model="keyword" @keydown="searchEnter">
                    <template #suffix>
                        <el-icon class="doc-nav__search-icon">
                            <Search @click="search" />
                        </el-icon>
                    </template>
                </el-input>
            </div>
            <div class="doc-nav__title" @click="indexPage">{{ this.collected.name }}</div>
            <div class="doc-nav__tree">
                <el-tree class="nav-tree" :data="this.collected.docLites" node-key="id" default-expand-all
                    :expand-on-click-node="false" @node-click="goDocPage">
                    <template #default="{ data }">
                        <span v-if="length(data.title) < 35" class="nav-tree__item"
                            :class="{ 'is-active': data.id === this.docId }"><em v-if="data.isAi" class="doc-ai-mark">AI</em>{{ data.title }}</span>
                        <el-tooltip v-else effect="dark" :content="data.title" placement="right">
                            <span class="nav-tree__item"
                                :class="{ 'is-active': data.id === this.docId }"><em v-if="data.isAi" class="doc-ai-mark">AI</em>{{ data.title }}</span>
                        </el-tooltip>
                    </template>
                </el-tree>
            </div>
        </el-aside>

        <el-container>
            <el-main ref="docContainer" id="docContainer" class="doc-main">
                <!-- 这里是为了手机端查看文集，做了适配，这段代码算是冗余代码，后续有空了再优化 -->
                <div id="doc-menu-button" v-if="isShowMenuButton">
                    <el-affix :offset="60">
                        <el-button class="doc-nav-toggle" type="primary"
                            @click="isShowDrawerMenu = true">导航</el-button>
                    </el-affix>
                    <el-drawer v-model="isShowDrawerMenu" title="I am the title" :with-header="false" direction="ltr"
                        size="80%">
                        <div class="doc-nav-drawer">
                            <div class="doc-nav__search">
                                <el-input placeholder="搜索文档" v-model="keyword" @keydown="searchEnter">
                                    <template #suffix>
                                        <el-icon class="doc-nav__search-icon">
                                            <Search @click="search" />
                                        </el-icon>
                                    </template>
                                </el-input>
                            </div>
                            <div class="doc-nav__title" @click="indexPage">{{ this.collected.name }}</div>
                            <el-tree class="nav-tree" :data="this.collected.docLites" node-key="id"
                                default-expand-all :expand-on-click-node="false" @node-click="goDocPage">
                                <template #default="{ data }">
                                    <span v-if="length(data.title) < 35" class="nav-tree__item"
                                        :class="{ 'is-active': data.id === this.docId }"><em v-if="data.isAi" class="doc-ai-mark">AI</em>{{ data.title }}</span>
                                    <el-tooltip v-else effect="dark" :content="data.title" placement="right">
                                        <span class="nav-tree__item"
                                            :class="{ 'is-active': data.id === this.docId }"><em v-if="data.isAi" class="doc-ai-mark">AI</em>{{ data.title }}</span>
                                    </el-tooltip>
                                </template>
                            </el-tree>
                        </div>
                    </el-drawer>
                </div>

                <!-- 文集首页 -->
                <div v-if="pageMode === 'index'" class="doc-body doc-index">
                    <div class="doc-index__title">{{ this.collected.name }}</div>
                    <el-row>
                        <el-col :span="20" :offset="2">
                            <el-tabs v-model="activeName" @tab-click="handleTabClick">
                                <el-tab-pane label="简介" name="first">
                                    <textarea class="doc-intro" readonly
                                        v-model="this.collected.description"></textarea>
                                </el-tab-pane>
                                <el-tab-pane label="目录" name="second">
                                    <el-table class="doc-table" :data="this.collected.docLites" style="width: 100%">
                                        <el-table-column label="" width="500">
                                            <template #default="{ row }">
                                                <em v-if="row.isAi" class="doc-ai-mark">AI</em>{{ row.title }}
                                            </template>
                                        </el-table-column>
                                        <el-table-column prop="updateTime" label="" align="right"></el-table-column>
                                    </el-table>
                                </el-tab-pane>
                                <el-tab-pane label="最近文档" name="third">最近更新的文档列表</el-tab-pane>
                                <el-tab-pane label="权限及成员" name="fourth">
                                    <el-table class="doc-table" :data="this.collected.sysUserLites"
                                        style="width: 100%">
                                        <el-table-column prop="realName" label="姓名" width="180"></el-table-column>
                                        <el-table-column prop="email" label="邮箱"></el-table-column>
                                        <el-table-column prop="memberDesc" label="成员角色"></el-table-column>
                                    </el-table>
                                </el-tab-pane>
                                <el-tab-pane label="知识网络" name="ilinkRelation">
                                    <doc-ilink-relation v-bind:data="this.collected"
                                        ref="docIlinkRef"></doc-ilink-relation>
                                </el-tab-pane>
                            </el-tabs>
                        </el-col>
                    </el-row>
                </div>
                <div v-else class="doc-body">
                    <!-- 文档标题 -->
                    <div v-if="this.isShowTitle" class="doc-header">
                        <h1 class="doc-title"><em v-if="doc.isAi" class="doc-ai-mark">AI</em>{{ this.doc.title }}</h1>
                    </div>
                    <div v-if="this.lockUser && this.lockUser.realName" class="doc-header">
                        <el-tag class="doc-lock" type="warning" size="small" effect="plain">{{
                            this.lockUser.realName }}
                            编辑锁定</el-tag>
                    </div>

                    <!-- 文档内容 -->
                    <v-md-editor v-model="this.doc.content" mode="preview" ref="editor"
                        @copy-code-success="handleCopyCodeSuccess" @image-click="handleImageClick" />

                    <!-- 图片查看大图 -->
                    <el-image-viewer v-if="isShowImageViewer" :url-list="imageViewerUrlList"
                        :initial-index="imageViewerIndex" teleported hide-on-click-modal
                        @close="isShowImageViewer = false">
                        <!-- 图片进度：第几张 / 共几张 -->
                        <template #progress="{ activeIndex, total }">
                            <span v-if="total > 1" class="image-viewer-progress">第 {{ activeIndex + 1 }} 张 / 共
                                {{ total }} 张</span>
                            <span v-else class="image-viewer-progress">共 {{ total }} 张图片</span>
                        </template>
                        <!-- 自定义工具栏 -->
                        <template #toolbar="{ actions, prev, next, reset, activeIndex, setActiveItem }">
                            <el-icon @click="prev"><Back /></el-icon>
                            <el-icon @click="next"><Right /></el-icon>
                            <el-icon @click="setActiveItem(imageViewerUrlList.length - 1)"><DArrowRight /></el-icon>
                            <el-icon @click="actions('zoomOut')"><ZoomOut /></el-icon>
                            <el-icon @click="actions('zoomIn', { enableTransition: false, zoomRate: 2 })"><ZoomIn /></el-icon>
                            <el-icon @click="actions('clockwise', { rotateDeg: 180, enableTransition: false })">
                                <RefreshRight /></el-icon>
                            <el-icon @click="actions('anticlockwise')"><RefreshLeft /></el-icon>
                            <el-icon @click="reset"><Refresh /></el-icon>
                            <el-icon @click="downloadImage(activeIndex)"><Download /></el-icon>
                        </template>
                    </el-image-viewer>

                    <el-divider class="doc-divider" />

                    <!-- 作者信息条 -->
                    <div class="doc-meta">
                        <el-tooltip class="item" effect="dark" content="参与编辑" placement="top">
                            <span class="doc-meta__item">
                                <el-icon>
                                    <User />
                                </el-icon>
                                <span v-for="ctor in contributors" :key="ctor" class="doc-meta__name">{{
                                    ctor.realName }}</span>
                            </span>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" :content="'更新于 ' + this.doc.updateTime + ''"
                            placement="top">
                            <span class="doc-meta__item">
                                <el-icon>
                                    <Clock />
                                </el-icon>
                                <span>{{ this.doc.updateTime }}</span>
                            </span>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" :content="'浏览次数：' + this.readCount" placement="top">
                            <span class="doc-meta__item">
                                <el-icon>
                                    <Reading />
                                </el-icon>
                                <span>{{ this.readCount }}</span>
                            </span>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" :content="'评论：' + this.commentCount" placement="top">
                            <span class="doc-meta__item">
                                <el-icon>
                                    <ChatDotSquare />
                                </el-icon>
                                <span>{{ this.commentCount }}</span>
                            </span>
                        </el-tooltip>
                    </div>

                    <!-- 点赞及点赞人员 -->
                    <div class="thumb-box">
                        <el-button class="thumb-box__btn" :type="this.myThumb.isSupporter ? 'primary' : ''" circle
                            @click="createThumb">
                            <el-icon>
                                <Pointer />
                            </el-icon>
                        </el-button>
                        <p class="thumb-box__count">{{ this.thumbCount }} 人点赞</p>
                        <div class="thumb-box__users">
                            <el-popover :width="300" placement="top" trigger="hover" v-for="item in thumbUserList"
                                :key="item">
                                <template #reference>
                                    <el-avatar class="thumb-box__avatar" :size="56"
                                        :src="currentAvatar(item.avatar)" />
                                </template>
                                <template #default>
                                    <div class="thumb-user">
                                        <el-avatar :size="120" :src="currentAvatar(item.avatar)" />
                                        <p class="thumb-user__name">{{ item.realName }}</p>
                                        <p class="thumb-user__email">{{ item.email }}</p>
                                        <p class="thumb-user__desc">暂无描述</p>
                                    </div>
                                </template>
                            </el-popover>
                        </div>
                    </div>

                    <!-- 已读用户列表 -->
                    <div class="read-users">
                        <el-tag v-for="item in readUserList" :key="item" class="read-users__tag" type="" size="small"
                            effect="plain" round>
                            {{ item.realName }}
                        </el-tag>
                        <p class="read-users__count">{{ this.readUserList.length }} 人已读</p>
                    </div>

                    <!-- 评论 -->
                    <div class="comment-section">
                        <div class="comment-section__head">所有评论（{{ this.commentCount }}）</div>
                        <div class="comment-list">
                            <div v-for="item in commentList" :key="item.id" class="comment">
                                <el-avatar class="comment__avatar" :size="36"
                                    :src="currentAvatar(item.createUser.avatar)">{{ item.createUser.realName }}</el-avatar>
                                <div class="comment__main">
                                    <div class="comment__meta">
                                        <span class="comment__name">{{ item.createUser.realName }}</span>
                                        <span class="comment__reply-to"
                                            @click="replyComment(item.id, item.replyUserId)">{{ item.replyUser &&
                                                item.replyUser.realName ? '回复 ' + item.replyUser.realName : '' }}</span>
                                        <span class="comment__time">{{ item.createTime }}</span>
                                        <span class="comment__action"
                                            @click="replyComment(item.id, item.createUserId)">回复</span>
                                    </div>
                                    <div class="comment__content">{{ item.content }}</div>
                                </div>
                            </div>
                        </div>

                        <div class="comment-form" v-if="isLogin" id="docCommentBlock">
                            <el-input v-model="inputComment.text" maxlength="500"
                                placeholder="请发表有价值的评论， 请勿灌水，良好的团队氛围需大家一起维护。" show-word-limit
                                type="textarea" />
                            <div class="comment-form__actions">
                                <el-select v-model="inputComment.replyUserId" class="comment-form__reply"
                                    placeholder="回复..." size="small" clearable>
                                    <el-option v-for="item in replyUserList" :key="item.id" :label="item.realName"
                                        :value="item.id" />
                                </el-select>
                                <el-button class="comment-form__btn" type="primary" size="small"
                                    @click="createComment()">评论</el-button>
                            </div>
                        </div>
                    </div>

                    <!-- 底部预留高度 -->
                    <div class="doc-body__bottom-space"></div>
                </div>
            </el-main>
        </el-container>
        <!-- 大纲导航（无标题时不展示） -->
        <el-aside id="doc-anchor-aside" class="doc-outline"
            v-if="pageMode === 'detail' && isShowAnchor && titles.length > 0" width="250px">
            <div class="doc-outline__inner">
                <el-anchor :container="'#docContainer'" direction="vertical" type="default">
                    <el-anchor-link v-for="anchor in titles" :key="anchor" :href="`#${anchor.titleId}`">
                        <span class="doc-outline__item"
                            :style="{ padding: `0px 0px 0px ${anchor.indent * 12}px` }">{{ anchor.title }}</span>
                    </el-anchor-link>
                </el-anchor>
            </div>
        </el-aside>
    </el-container>

    <div v-if="pageMode === 'detail'">
        <!-- ========== ========== ========== 右下角快捷按钮组 ========== ========== ==========  -->
        <div class="float-actions float-actions--comment">
            <el-badge :value="this.commentCount" class="item" :hidden="this.commentCount == 0">
                <el-button class="quick-btn" circle @click="this.scrollToBlock('comment')">
                    <el-icon>
                        <ChatDotSquare />
                    </el-icon>
                </el-button>
            </el-badge>
        </div>
        <div class="float-actions float-actions--thumb">
            <el-badge :value="this.thumbCount" class="item" :hidden="this.thumbCount == 0">
                <el-button v-if="this.myThumb.isSupporter" class="quick-btn" type="primary" circle
                    @click="createThumb">
                    <el-icon>
                        <Pointer />
                    </el-icon>
                </el-button>
                <el-button v-else class="quick-btn" circle @click="createThumb">
                    <el-icon>
                        <Pointer />
                    </el-icon>
                </el-button>
            </el-badge>
        </div>
        <div class="float-actions float-actions--top">
            <el-button class="quick-btn" circle @click="this.scrollToBlock('top')">
                <el-icon>
                    <CaretTop />
                </el-icon>
            </el-button>
        </div>
        <div class="float-actions float-actions--share">
            <el-button class="quick-btn" circle @click="this.copyShareUrl()">
                <el-icon>
                    <Share />
                </el-icon>
            </el-button>
        </div>
        <!-- ========== ========== ========== 右侧快捷按钮：工具条 ========== ========== ==========  -->
        <div class="float-actions float-actions--tool"
            v-if="isShowFunctionButton && this.$store.state.user.token != undefined && this.$store.state.user.token != ''">
            <el-popover placement="left" :width="360" trigger="click">
                <template #reference>
                    <el-button class="quick-btn" type="primary" circle>
                        <el-icon>
                            <Menu />
                        </el-icon>
                    </el-button>
                </template>
                <div class="perm-panel">
                    <div class="perm-panel__item perm-panel__item--static" v-if="this.collectedPermission.detail">
                        <span>
                            <el-icon>
                                <Warning />
                            </el-icon>
                            -详情
                        </span>
                    </div>
                    <div class="perm-panel__item" v-if="this.collectedPermission.focus">
                        <span @click="docFocus()">
                            <el-icon>
                                <FullScreen />
                            </el-icon>
                            -预览
                        </span>
                    </div>
                    <div class="perm-panel__item" v-if="this.collectedPermission.his">
                        <span @click="history()">
                            <el-icon>
                                <TakeawayBox />
                            </el-icon>
                            -历史
                        </span>
                    </div>
                    <div class="perm-panel__item perm-panel__item--static" v-if="this.collectedPermission.member">
                        <span>
                            <el-icon>
                                <User />
                            </el-icon>
                            -协作
                        </span>
                    </div>
                    <div class="perm-panel__item" v-if="this.collectedPermission.create">
                        <span @click="createDoc()">
                            <el-icon>
                                <CirclePlus />
                            </el-icon>
                            -新建
                        </span>
                    </div>
                    <div class="perm-panel__item" v-if="this.collectedPermission.create">
                        <span @click="createChildDoc()">
                            <el-icon>
                                <CirclePlus />
                            </el-icon>
                            -子文档
                        </span>
                    </div>
                    <div class="perm-panel__item" v-if="this.collectedPermission.edit">
                        <span @click="editDoc()">
                            <el-icon>
                                <Edit />
                            </el-icon>
                            -编辑
                        </span>
                    </div>
                    <div class="perm-panel__item" v-if="this.collectedPermission.copy">
                        <span @click="copyDoc()">
                            <el-icon>
                                <DocumentCopy />
                            </el-icon>
                            -复制
                        </span>
                    </div>
                </div>
            </el-popover>
        </div>

        <!-- ========== ========== ========== 右侧快捷按钮：大纲导航 ========== ========== ==========  -->
        <div class="float-actions float-actions--outline" v-if="isShowFunctionButton && titles.length > 0">
            <el-button class="quick-btn" :class="{ 'is-active': isShowAnchor }" circle
                @click="isShowAnchor = !isShowAnchor">
                <el-icon>
                    <Tickets />
                </el-icon>
            </el-button>
        </div>
    </div>
    <div v-else>
        <div class="float-actions float-actions--comment">
            <el-button class="quick-btn" circle @click="this.colFocus()">
                <el-icon>
                    <Reading />
                </el-icon>
            </el-button>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import request from '../../utils/request.js';
import { ElMessageBox, ElMessage } from 'element-plus';
import { mdFormat } from '../../utils/mdtools';
import { length } from '../../utils/strings';
import { avatarImage } from '../../utils/users.js';
import DocIlinkRelation from './components/DocIlinkRelation';
import { copy } from '../../utils/clipboard.js';

export default {
    data() {
        return {
            isLogin: false,
            activeName: 'first',
            drawer: false,
            isShowAnchor: true,
            inputComment: {
                text: '',
                replyCommentId: '',
                replyUserId: ''
            },
            commentList: [],
            replyUserList: [],
            keyword: '',
            pageMode: 'index', // index 或者 detail
            collected: {},
            docId: '',
            doc: {},
            url: '',
            contributors: [],
            titles: [],
            thumbCount: 0,
            commentCount: 0,
            readCount: 0,
            myThumb: {},
            thumbUserList: [],
            readUserList: [],
            collectedPermission: {
                detail: false,
                focus: false,
                his: false,
                create: false,
                edit: false,
                copy: false,
                member: false
            },
            lockUser: {},
            isShowTitle: false,
            isShowFunctionButton: true,
            isShowMenuButton: false,
            isShowDrawerMenu: false,
            isShowImageViewer: false,
            imageViewerUrlList: [],
            imageViewerIndex: 0
        };
    },
    components: { DocIlinkRelation },
    mounted() {
        let token = this.$store.state.user.token;
        console.log('token: ' + token);

        if (this.$store.state.user.token == undefined || this.$store.state.user.token == '') {
            this.isLogin = false;
        } else {
            this.isLogin = true;
        }

        console.log('collectedId:' + this.$route.params.collectedId + ' docId:' + this.$route.params.docId);

        this.getCollected();

        this.docId = this.$route.params.docId;
        window.addEventListener('storage', this.HandleUiMsg);
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    beforeUnmount() {
        window.removeEventListener('storage', this.HandleUiMsg);
        window.removeEventListener('resize', this.handleResize);
    },
    created() { },
    methods: {
        handleResize(event) {
            this.fullWidth = document.documentElement.clientWidth;
            this.isShowAnchor = this.fullWidth > 1000;
            this.isShowFunctionButton = this.fullWidth > 1000;
            this.isShowMenuButton = this.fullWidth < 800;
        },
        HandleUiMsg(e) {
            if (e.key == 'ui-msg') {
                debugger;
                console.log(e.key, e.newValue, e.oldValue);
                if (JSON.parse(e.newValue).element == 'doc' && JSON.parse(e.newValue).id == this.docId) {
                    this.getDoc(this.docId);
                }
            }
        },
        copyShareUrl() {
            let s = '[' + this.collected.name + ' / ' + this.doc.title + '] ' + location.href;
            copy(s);
            ElMessage({
                message: '复制成功',
                type: 'success',
                duration: 1 * 1000
            });
        },
        length(s) {
            return length(s);
        },
        search() {
            this.getCollected();
        },
        searchEnter(e) {
            if (e.keyCode == 13) {
                this.getCollected();
            }
        },
        indexPage() {
            this.pageMode = 'index';
            this.docId = '';
            this.$router.push({ name: 'collected', params: { collectedId: this.collected.id, docId: '_intro' } });

            if (this.activeName == 'ilinkRelation') {
                this.$nextTick(() => {
                    this.$refs.docIlinkRef.ilinkRelation(this.$route.params.collectedId);
                });
            }
        },
        detailPage() {
            this.pageMode = 'detail';
        },
        getCollected() {
            // 查询文集详情
            request({
                url: '/collected/get',
                method: 'post',
                data: {
                    id: this.$route.params.collectedId,
                    keyword: this.keyword
                }
            }).then(res => {
                if (res.code == 0) {
                    this.collected = res.meta.collected;

                    // 查询操作权限清单
                    if (this.isLogin) {
                        request({
                            url: '/collected/permission',
                            method: 'post',
                            data: {
                                id: this.$route.params.collectedId
                            }
                        }).then(res => {
                            if (res.code == 0) {
                                this.collectedPermission = res.meta;
                            }
                        });
                    }

                    switch (this.$route.params.docId) {
                        case '_intro':
                            document.title = this.collected.name;
                            break;
                        default:
                            this.$nextTick(() => {
                                this.getDoc(this.$route.params.docId);
                            });

                            break;
                    }
                }
            });
        },
        handleTabClick(pane, ev) {
            switch (pane.paneName) {
                case 'ilinkRelation':
                    //this.ilinkRelation(this.$route.params.collectedId);
                    // docIlinkRef.value.ilinkRelation(this.$route.params.collectedId);
                    this.$refs.docIlinkRef.ilinkRelation(this.$route.params.collectedId);
                    break;
                default:
                    break;
            }
        },
        getDoc(id) {
            request({
                url: '/doc/get',
                method: 'post',
                data: {
                    id: id
                }
            }).then(res => {
                if (res.code == 0) {
                    this.doc = res.meta.doc;

                    // 判断标题的展示方式，如果开头的章节名称和标题一样，则隐藏标题
                    let _titleDefaultSame = true;
                    let array = _.split(this.doc.content, '\n');
                    if (array[0].startsWith('#')) {
                        if (array[0].indexOf('# @ ') >= 0) {
                            let title = array[0].substring(array[0].indexOf('# @ ') + 4);
                            let titleSame = title.indexOf(this.doc.title);
                            if (titleSame >= 0) {
                                _titleDefaultSame = false;
                            }
                        }
                    }
                    this.isShowTitle = _titleDefaultSame;

                    // 预览前对文本进行处理，然后再渲染预览
                    this.doc.content = mdFormat(this.doc.content, res.meta);

                    document.title = this.doc.title;
                    this.contributors = [];
                    if (res.meta.contributors && res.meta.contributors.length > 0) {
                        this.contributors = res.meta.contributors;
                    }
                    if (res.meta.user) {
                        this.lockUser = res.meta.user;
                        console.log('lockUser:' + this.lockUser);
                    } else {
                        this.lockUser = {};
                    }
                    // 已读用户列表
                    if (res.meta.readUserList) {
                        this.readUserList = res.meta.readUserList;
                    } else {
                        this.readUserList = [];
                    }
                    // 可回复用户列表
                    this.replyUserList = res.meta.replyUserList;
                    // 点赞数
                    this.thumbCount = res.meta.thumbCount;
                    if (res.meta.myThumb) {
                        this.myThumb = res.meta.myThumb;
                    }
                    if (res.meta.readCount) {
                        this.readCount = res.meta.readCount;
                    }
                    if (res.meta.commentCount) {
                        this.commentCount = res.meta.commentCount;
                    }
                    this.pageMode = 'detail';

                    this.getThumbUserList();

                    this.queryComment();

                    this.$nextTick(() => {
                        // 界面处理-1：预览中设置标题层级导航栏
                        const anchors = this.$refs.editor.$el.querySelectorAll('.v-md-editor-preview h1,h2,h3,h4,h5,h6');
                        const titles = Array.from(anchors).filter(title => !!title.innerText.trim());
                        if (!titles.length) {
                            this.titles = [];
                            // return;
                        } else {
                            // 这里给titles设置id，方便后续通过id来定位
                            titles.forEach((title, index) => {
                                try {
                                    title.setAttribute('id', `doc-title-${parseInt(index) + 1}`);
                                } catch (err) {
                                    console.log('设置标题定位ID失败');
                                }
                            });
                            const hTags = Array.from(new Set(titles.map(title => title.tagName))).sort();
                            // 展示一共有几级标题，如：H1、H2、H3，后续使用排序来确认层级
                            console.log(hTags);
                            this.titles = titles.map(el => ({
                                title: el.innerText,
                                lineIndex: el.getAttribute('data-v-md-line'),
                                indent: hTags.indexOf(el.tagName),
                                titleId: el.getAttribute('id'),
                            }));
                        }
                        console.log('titles:');
                        console.log(this.titles);

                        // 界面处理-2：锚点定位（定位可能失败，增加异常处理）
                        // 支持两种锚点：
                        // 1、段落标题定位，中文名称定位，重复名称会定位错误
                        // 2、常规锚点定位，使用元素ID来定位，需要使用html元素标签设置ID值
                        try {
                            let hash = document.location.hash.replaceAll('#', '');
                            if (hash != '') {
                                if (hash.indexOf('$') >= 0) {
                                    // 文档小标题定位
                                    console.log('存在标题描述，需要定位：' + hash);
                                    let title = decodeURI(hash.replaceAll('$', ''));
                                    for (var i = 0; i < this.titles.length; i++) {
                                        let titleItem = this.titles[i];
                                        if (titleItem.title === title) {
                                            this.handleAnchorClick(titleItem);
                                            console.log('锚点定位完成，已到达指定位置');
                                            break;
                                        }
                                    }
                                } else {
                                    // 常规锚点定位
                                    console.log('存在常规锚点，需要定位：' + hash);
                                    document.getElementById(hash).scrollIntoView(true);
                                    console.log('锚点定位完成，已到达指定位置');
                                }
                            }
                        } catch (err) {
                            // catchCode - 捕获错误的代码块
                            console.log('锚点定位失败，可能是锚点不存在');
                        } finally {
                            // finallyCode - 无论 try / catch 结果如何都会执行的代码块
                        }
                    });
                }
            });
        },
        goDocPage(data) {
            this.docId = data.id;
            this.$router.push({ name: 'collected', params: { collectedId: this.collected.id, docId: this.docId } });
            this.getDoc(this.docId);
            document.getElementById('docContainer').scrollTop = 0;
        },
        docPage(id) {
            this.docId = id;
            this.$router.push({ name: 'collected', params: { collectedId: this.collected.id, docId: id } });
            this.getDoc(id);
            document.getElementById('docContainer').scrollTop = 0;
        },
        getThumbUserList() {
            request({
                url: '/openapi/docthumb/userList',
                method: 'post',
                data: {
                    tableName: 'doc',
                    dataId: this.docId
                }
            }).then(res => {
                if (res.code == 0) {
                    this.thumbUserList = res.meta.userLiteList;
                }
            });
        },
        createThumb() {
            if (!this.isLogin) {
                ElMessage({
                    message: '点赞请先登录哦~',
                    type: 'warning',
                    duration: 1 * 1000
                });
                return false;
            }

            var thumbValue = true;
            if (this.myThumb != undefined && this.myThumb.isSupporter != undefined) {
                thumbValue = !this.myThumb.isSupporter;
            }

            request({
                url: '/docthumb/create',
                method: 'post',
                data: {
                    tableName: 'doc',
                    dataId: this.docId,
                    type: 'supporter',
                    value: thumbValue
                }
            }).then(res => {
                if (res.code == 0) {
                    this.thumbCount = res.meta.thumbCount;
                    this.myThumb = res.meta.myThumb;

                    this.getThumbUserList();
                }
            });
        },
        createComment() {
            if (!this.isLogin) {
                ElMessage({
                    message: '查看评论请先登录哦~',
                    type: 'warning',
                    duration: 1 * 1000
                });
                return false;
            }

            if (this.inputComment.text && this.inputComment.text.length > 0) {
                request({
                    url: '/doccomment/create',
                    method: 'post',
                    data: {
                        docId: this.docId,
                        content: this.inputComment.text,
                        replyCommentId: this.inputComment.replyCommentId,
                        replyUserId: this.inputComment.replyUserId
                    }
                }).then(res => {
                    if (res.code == 0) {
                        this.inputComment = {
                            text: '',
                            replyCommentId: '',
                            replyUserId: ''
                        };
                        this.queryComment();

                        ElMessage({
                            message: '评论完成~',
                            type: 'success',
                            duration: 1 * 1000
                        });
                    }
                });
            } else {
                ElMessage({
                    message: '请输入评论内容~',
                    type: 'warning',
                    duration: 1 * 1000
                });
            }
        },
        queryComment() {
            request({
                url: '/openapi/doccomment/list',
                method: 'post',
                data: {
                    docId: this.docId
                }
            }).then(res => {
                if (res.code == 0) {
                    this.commentList = res.data;
                }
            });
        },
        replyComment(commentId, userId) {
            console.log('comment-id: ' + commentId + ', user-id: ' + userId);

            this.inputComment = {
                // text: '',
                replyCommentId: commentId,
                replyUserId: userId
            };
        },
        currentAvatar(createUserAvatar) {
            return avatarImage(createUserAvatar);
        },
        handleAnchorClick(anchor) {
            console.log('handleAnchorClick: ' + anchor);
            const { editor } = this.$refs;
            const { lineIndex } = anchor;

            const heading = editor.$el.querySelector(`.v-md-editor-preview [data-v-md-line="${lineIndex}"]`);

            if (heading) {
                // 正常滚动
                console.log('handleAnchorClick:' + heading.offsetTop);
                document.getElementById('docContainer').scrollTop = heading.offsetTop;
                // 平滑滚动（经测试，不怎么平滑，有点抽风，可能是参数没调整正确）
                // const targetElement = document.getElementById(anchor.titleId);
                // if (targetElement) {
                //     targetElement.scrollIntoView({
                //         behavior: 'smooth',
                //         block: 'start'
                //     });
                // }
            } else {
                document.getElementById('docContainer').scrollTop = 0;
            }
        },
        handleCopyCodeSuccess(code) {
            // console.log(code);
            ElMessage({
                message: '复制成功',
                type: 'success',
                duration: 1 * 1000
            });
        },
        // 点击图片查看大图
        handleImageClick(images, currentIndex) {
            if (!images || images.length == 0) {
                return;
            }
            this.imageViewerUrlList = images;
            this.imageViewerIndex = currentIndex;
            this.isShowImageViewer = true;
        },
        // 下载当前预览的图片
        downloadImage(index) {
            const url = this.imageViewerUrlList[index];
            if (!url) {
                return;
            }
            const link = document.createElement('a');
            link.href = url;
            link.download = url.split('?')[0].split('/').pop() || 'image';
            link.target = '_blank';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        scrollToBlock(block) {
            switch (block) {
                case 'top':
                    document.getElementById('docContainer').scrollTop = 0;
                    break;
                case 'comment':
                    document.getElementById('docCommentBlock').scrollIntoView(true);
                    break;
            }
        },
        // 专注模式
        docFocus() {
            let routeData = this.$router.resolve({
                name: 'docfocus',
                params: { docId: this.$route.params.docId }
            });
            window.open(routeData.path, '_blank');
        },
        // 专注模式（文集）
        colFocus() {
            let routeData = this.$router.resolve({
                name: 'colfocus',
                params: { collectedId: this.$route.params.collectedId }
            });
            window.open(routeData.path, '_blank');
        },
        history() {
            console.log('查看历史');

            let routeData = this.$router.resolve({
                name: 'workbench_history',
                params: { collectedId: this.collected.id, docId: this.doc.id }
            });
            window.open(routeData.path, '_blank');
        },
        createDoc() {
            console.log('创建文档');

            let parentDocId = '_blank';
            if (this.doc.parentDocId != '') parentDocId = this.doc.parentDocId;

            let routeData = this.$router.resolve({
                name: 'workbench_editor',
                params: { collectedId: this.collected.id, docId: '_create', parentDocId: parentDocId, copyDocId: '_none' }
            });
            window.open(routeData.path, '_blank');
            // this.$router.push(routeData.path);
        },
        createChildDoc() {
            console.log('创建子文档');

            let routeData = this.$router.resolve({
                name: 'workbench_editor',
                params: { collectedId: this.collected.id, docId: '_create', parentDocId: this.doc.id, copyDocId: '_none' }
            });
            window.open(routeData.path, '_blank');
            // this.$router.push(routeData.path);
        },
        // 编辑
        editDoc() {
            console.log('编辑');
            console.log(this.doc);
            let parentDocId = '_blank';
            if (this.doc.parentDocId != '') parentDocId = this.doc.parentDocId;

            let routeData = this.$router.resolve({
                name: 'workbench_editor',
                params: { collectedId: this.collected.id, docId: this.doc.id, parentDocId: parentDocId, copyDocId: '_none' }
            });
            window.open(routeData.path, '_blank');
        },
        // 复制
        copyDoc() {
            console.log('复制文档');

            let parentDocId = '_blank';
            if (this.doc.parentDocId != '') parentDocId = this.doc.parentDocId;

            let routeData = this.$router.resolve({
                name: 'workbench_editor',
                params: { collectedId: this.collected.id, docId: '_create', parentDocId: parentDocId, copyDocId: this.doc.id }
            });
            window.open(routeData.path, '_blank');
        }
    }
};
</script>

<style lang="scss" scoped>
/* ============================================================
   文集页（文档预览）
   视觉语言与登录页 / 首页 / 顶栏保持一致：浅色画布上的白色面板 + 细描边 + 低饱和长投影
   ============================================================ */
.collected-page {
    /* 局部覆盖主色，避免影响其它页面 */
    --el-color-primary: #2f6fed;
    --el-color-primary-light-3: #6d9af2;
    --el-color-primary-light-5: #97b7f6;
    --el-color-primary-light-7: #c1d4fa;
    --el-color-primary-light-8: #d5e2fb;
    --el-color-primary-light-9: #eaf1fd;
    --el-color-primary-dark-2: #2659be;

    --cp-text: #1f2d3d;
    --cp-text-sub: #5b6a80;
    --cp-text-weak: #8a94a6;
    --cp-line: #e6eaf0;
    --cp-hairline: #eef1f6;

    box-sizing: border-box;
    height: 100%;
    color: var(--cp-text);
}

/* ---------- 面板：左目录 / 正文 / 大纲 ---------- */
.doc-nav,
.doc-main,
.doc-outline {
    background-color: #ffffff;
    border: 1px solid var(--cp-line);
    border-radius: 14px;
    box-shadow: 0 1px 2px rgba(28, 47, 84, 0.05);
}

/* ---------- 左侧目录 ---------- */
.doc-nav {
    display: flex;
    flex-direction: column;
    margin-right: 14px;
    padding: 10px;
    overflow: hidden;
}

.doc-nav__search {
    flex: none;
    margin-bottom: 8px;
}

.doc-nav__search :deep(.el-input__wrapper) {
    height: 34px;
    border-radius: 9px;
    background-color: #f7f9fc;
    box-shadow: 0 0 0 1px var(--cp-line) inset;
    transition: box-shadow 0.2s, background-color 0.2s;
}

.doc-nav__search :deep(.el-input__wrapper:hover) {
    box-shadow: 0 0 0 1px #cfd8e6 inset;
}

.doc-nav__search :deep(.el-input__wrapper.is-focus) {
    background-color: #ffffff;
    box-shadow: 0 0 0 1px var(--el-color-primary) inset,
        0 0 0 3px var(--el-color-primary-light-8);
}

.doc-nav__search-icon {
    color: #9aa6b8;
    cursor: pointer;
    transition: color 0.2s;
}

.doc-nav__search-icon:hover {
    color: var(--el-color-primary);
}

.doc-nav__title {
    flex: none;
    padding: 9px 10px;
    border-bottom: 1px solid var(--cp-hairline);
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: var(--cp-text);
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: color 0.2s;
}

.doc-nav__title:hover {
    color: var(--el-color-primary);
}

.doc-nav__tree {
    flex: 1 1 auto;
    min-height: 0;
    padding: 6px 0 8px;
    overflow-y: auto;
}

/* 目录树（左侧面板与移动端抽屉共用） */
.nav-tree {
    background-color: transparent;
}

.nav-tree :deep(.el-tree-node__content) {
    height: 32px;
    padding-right: 6px;
    border-radius: 8px;
    transition: background-color 0.2s;
}

.nav-tree :deep(.el-tree-node__content:hover) {
    background-color: #f6f9ff;
}

.doc-ai-mark {
    display: inline-block;
    margin-right: 6px;
    padding: 0 4px;
    border-radius: 4px;
    background: #eaf1fd;
    color: #2f6fed;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: 16px;
    vertical-align: 1px;
}
.nav-tree__item {
    display: block;
    flex: 1 1 auto;
    min-width: 0;
    padding: 0 8px;
    border-radius: 8px;
    font-size: 13px;
    line-height: 32px;
    color: var(--cp-text-sub);
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: background-color 0.2s, color 0.2s;
}

.nav-tree__item:hover {
    color: var(--cp-text);
}

.nav-tree__item.is-active {
    background-color: var(--el-color-primary-light-9);
    color: var(--el-color-primary);
    font-weight: 600;
}

/* 移动端抽屉里的目录容器 */
.doc-nav-drawer {
    height: 100%;
    padding: 12px;
    overflow-y: auto;
}

/* ---------- 正文区 ---------- */
.doc-main {
    padding: 0;
    overflow-y: auto;
}

.doc-body {
    max-width: 1080px;
    margin: 0 auto;
    padding: 24px 16px 8px;
}

/* markdown 与各区块统一横向间距，避免与正文对不齐 */
.doc-body :deep(.v-md-editor-preview),
.doc-body :deep(.vuepress-markdown-body) {
    padding-left: 0;
    padding-right: 0;
}

/* 代码块自带左右 -1.5rem 负外边距（用于抵扣主题的 2.5rem 内边距），需一并归零，
   否则代码块两侧溢出，行号列与复制按钮会被裁切 */
.doc-body :deep(.vuepress-markdown-body div[class*=v-md-pre-wrapper-]) {
    margin-left: 0;
    margin-right: 0;
}

.doc-body__bottom-space {
    height: 80px;
}

/* 文档标题 */
.doc-header {
    text-align: center;
}

.doc-title {
    margin: 0;
    padding: 4px 0 2px;
    font-size: 26px;
    font-weight: 600;
    line-height: 1.35;
    letter-spacing: 0.3px;
    color: var(--cp-text);
}

.doc-lock {
    margin-top: 6px;
}

/* markdown 正文（保留原有修复：避免代码块自带滚动条） */
.doc-body :deep(.vuepress-markdown-body) {
    overflow: hidden;
    color: var(--cp-text);
    font-size: 16px;
    line-height: 1.8;
}

.doc-body .doc-divider {
    margin: 24px 0 0;
    border-color: var(--cp-hairline);
}

/* 作者信息条 */
.doc-meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 8px 20px;
    padding-top: 16px;
    font-size: 13px;
    color: var(--cp-text-weak);
}

.doc-meta__item {
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

.doc-meta__item .el-icon {
    font-size: 14px;
}

.doc-meta__name {
    margin-right: 8px;
}

/* ---------- 点赞区 ---------- */
.thumb-box {
    margin: 80px auto 0;
    max-width: 600px;
    padding: 24px 20px;
    border: 1px solid var(--cp-line);
    border-radius: 14px;
    background-color: #ffffff;
    box-shadow: 0 1px 2px rgba(28, 47, 84, 0.05);
    text-align: center;
}

.thumb-box .thumb-box__btn {
    width: 60px;
    height: 60px;
    font-size: 28px;
    box-shadow: 0 8px 18px -8px rgba(47, 111, 237, 0.5);
}

.thumb-box__count {
    margin: 12px 0 0;
    font-size: 13px;
    color: var(--cp-text-weak);
}

.thumb-box__users {
    margin-top: 12px;
}

.thumb-box__avatar {
    margin: 6px;
    transition: transform 0.2s;
}

.thumb-box__avatar:hover {
    transform: translateY(-2px);
}

.thumb-user {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 20px;
}

.thumb-user__name {
    margin: 0;
    font-size: 14px;
    font-weight: 500;
    color: var(--cp-text);
}

.thumb-user__email {
    margin: 0;
    font-size: 13px;
    color: var(--cp-text-weak);
}

.thumb-user__desc {
    margin: 0;
    font-size: 13px;
    color: var(--cp-text-sub);
}

/* ---------- 已读用户 ---------- */
.read-users {
    padding-top: 32px;
    text-align: center;
}

.read-users__tag {
    margin: 3px;
}

.read-users__count {
    margin: 10px 0 0;
    font-size: 13px;
    color: var(--cp-text-weak);
}

/* ---------- 评论区 ---------- */
.comment-section {
    margin-top: 80px;
}

.comment-section__head {
    font-size: 14px;
    font-weight: 600;
    color: var(--cp-text);
}

.comment-list {
    margin-top: 4px;
}

.comment {
    display: flex;
    gap: 12px;
    padding: 16px 0;
    border-bottom: 1px solid var(--cp-hairline);
}

.comment__avatar {
    flex: none;
}

.comment__main {
    flex: 1 1 auto;
    min-width: 0;
}

.comment__meta {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 4px 10px;
    font-size: 13px;
    color: var(--cp-text-weak);
}

.comment__name {
    font-weight: 600;
    color: var(--cp-text);
}

.comment__reply-to {
    cursor: pointer;
    transition: color 0.2s;
}

.comment__reply-to:hover {
    color: var(--el-color-primary);
}

.comment__action {
    color: var(--el-color-primary);
    cursor: pointer;
}

.comment__action:hover {
    color: var(--el-color-primary-dark-2);
}

.comment__content {
    margin-top: 6px;
    font-size: 14px;
    line-height: 1.7;
    color: var(--cp-text);
    word-break: break-word;
    white-space: pre-wrap;
}

.comment-form {
    margin-top: 16px;
    padding: 16px;
    border: 1px solid var(--cp-line);
    border-radius: 14px;
    background-color: #ffffff;
    box-shadow: 0 1px 2px rgba(28, 47, 84, 0.05);
}

.comment-form__actions {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 10px;
    margin-top: 10px;
}

.comment-form__reply {
    width: 160px;
}

.comment-form__btn {
    height: 32px;
    border-radius: 9px;
}

/* ---------- 文集首页（index 模式） ---------- */
.doc-index__title {
    margin-bottom: 14px;
    font-size: 26px;
    font-weight: 600;
    line-height: 1.35;
    letter-spacing: 0.3px;
    text-align: center;
    color: var(--cp-text);
}

.doc-intro {
    display: block;
    width: 100%;
    height: 500px;
    padding: 0;
    border: 0;
    outline: none;
    resize: none;
    background-color: transparent;
    font-family: inherit;
    font-size: 15px;
    line-height: 1.8;
    color: var(--cp-text);
}

.doc-index :deep(.el-tabs__header) {
    margin-bottom: 18px;
}

.doc-index :deep(.el-tabs__nav-wrap::after) {
    height: 1px;
    background-color: var(--cp-line);
}

.doc-index :deep(.el-tabs__item) {
    font-size: 14px;
    font-weight: 500;
    color: var(--cp-text-weak);
}

.doc-index :deep(.el-tabs__item.is-active) {
    color: var(--el-color-primary);
}

.doc-index :deep(.el-tabs__active-bar) {
    height: 2px;
    border-radius: 2px;
}

.doc-table {
    --el-table-header-bg-color: #f7f9fc;
    font-size: 13px;
}

.doc-table :deep(th.el-table__cell) {
    color: var(--cp-text-weak);
    font-weight: 600;
}

.doc-table :deep(.el-table__cell) {
    padding: 10px 0;
}

/* ---------- 大纲导航 ---------- */
.doc-outline {
    margin-left: 14px;
    overflow: hidden;
}

.doc-outline__inner {
    height: 100%;
    padding: 24px 12px 40px;
    overflow-y: auto;
}

.doc-outline :deep(.el-anchor__link) {
    font-size: 13px;
    color: var(--cp-text-sub);
}

.doc-outline :deep(.el-anchor__link:hover) {
    color: var(--cp-text);
}

.doc-outline :deep(.el-anchor__link.is-active) {
    color: var(--el-color-primary);
    font-weight: 500;
}

.doc-outline :deep(.el-anchor__marker) {
    border-radius: 2px;
}

/* ---------- 悬浮快捷按钮 ---------- */
.float-actions {
    position: fixed;
    right: 20px;
    z-index: 9999;
}

.float-actions--comment {
    bottom: 50px;
}

.float-actions--thumb {
    bottom: 100px;
}

.float-actions--top {
    bottom: 150px;
}

.float-actions--share {
    bottom: 200px;
}

.float-actions--tool {
    top: 60px;
    right: 70px;
}

.float-actions--outline {
    top: 60px;
    right: 20px;
}

.float-actions .quick-btn {
    width: 40px;
    height: 40px;
    font-size: 18px;
    box-shadow: 0 4px 10px rgba(28, 47, 84, 0.12);
    transition: transform 0.2s, box-shadow 0.2s, color 0.2s, border-color 0.2s,
        background-color 0.2s;
}

/* 非主色按钮：白底 + 弱描边（主色按钮保持自身配色） */
.float-actions .quick-btn:not(.el-button--primary) {
    border-color: var(--cp-line);
    background-color: #ffffff;
    color: var(--cp-text-sub);
}

.float-actions .quick-btn:not(.el-button--primary):hover {
    border-color: var(--el-color-primary-light-7);
    background-color: var(--el-color-primary-light-9);
    color: var(--el-color-primary);
}

.float-actions .quick-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 20px -10px rgba(28, 47, 84, 0.3);
}

/* 大纲开关的选中态 */
.float-actions .quick-btn.is-active {
    border-color: var(--el-color-primary-light-7);
    background-color: var(--el-color-primary-light-9);
    color: var(--el-color-primary);
}

/* 权限 / 工具面板（el-popover 内容 teleport 到 body，元素本身仍带 scoped 标记） */
.perm-panel {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 14px 0;
    font-size: 14px;
    color: var(--cp-text-sub);
}

.perm-panel__item > span {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    cursor: pointer;
    transition: color 0.2s;
}

.perm-panel__item > span:hover {
    color: var(--el-color-primary);
}

/* 暂未开放的功能：危险色提示且不可点击 */
.perm-panel__item--static > span,
.perm-panel__item--static > span:hover {
    color: #f56c6c;
    cursor: default;
}

/* 移动端「导航」按钮 */
.doc-nav-toggle {
    height: 34px;
    margin-left: 16px !important;
    border-radius: 9px;
}

/* ---------- 滚动条：作用域限定，避免像以前那样全局生效 ---------- */
.doc-main::-webkit-scrollbar,
.doc-nav__tree::-webkit-scrollbar,
.doc-outline__inner::-webkit-scrollbar,
.doc-nav-drawer::-webkit-scrollbar {
    width: 6px;
    height: 6px;
}

.doc-main::-webkit-scrollbar-track,
.doc-nav__tree::-webkit-scrollbar-track,
.doc-outline__inner::-webkit-scrollbar-track,
.doc-nav-drawer::-webkit-scrollbar-track {
    border-radius: 10px;
}

.doc-main::-webkit-scrollbar-thumb,
.doc-nav__tree::-webkit-scrollbar-thumb,
.doc-outline__inner::-webkit-scrollbar-thumb,
.doc-nav-drawer::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #bfc1c4;
}

/* 图片查看器进度文字：加黑白描边，避免在浅色/深色图片上不清晰 */
.image-viewer-progress {
    font-size: 14px;
    font-weight: 500;
    color: #fff;
    text-shadow: -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000, 1px 1px 0 #000,
        0 -1px 0 #000, 0 1px 0 #000, -1px 0 0 #000, 1px 0 0 #000;
}

/* ---------- 小尺寸适配（与 JS 的 isShowMenuButton = fullWidth < 800 保持一致） ---------- */
@media screen and (max-width: 800px) {
    #doc-menu-aside {
        display: none;
    }

    .doc-body {
        padding-top: 12px;
    }

    .doc-title,
    .doc-index__title {
        font-size: 20px;
    }

    .thumb-box {
        margin-top: 40px;
        padding: 16px 12px;
    }

    .read-users {
        padding-top: 20px;
    }

    .comment-section {
        margin-top: 40px;
    }
}
</style>
